<div class="inner-content">
  <main class="project-info" *ngIf="infrastructure">
    <app-global-user-admin-table-step [infrastructure]="infrastructure"></app-global-user-admin-table-step>
    <app-global-user-admin-confirm-step [infrastructure]="infrastructure"></app-global-user-admin-confirm-step>
  </main>
</div>
